import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { fieldForceSecurityActionTypes } from '../actions/actionTypes';
import { updateFilterConfig, updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'FieldForceSecurityFilterList';

const logListReq = (action, state) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

function FFSecurityFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    case fieldForceSecurityActionTypes.UPDATE_FF_SECURITY_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case fieldForceSecurityActionTypes.UPDATE_FF_SECURITY_COLUMN_CONFIG:
      return {
        ...state,
        listSortOptions: action.data.sortOptions,
        listColumnOrder: action.data.columnOrder,
      };
    case fieldForceSecurityActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case fieldForceSecurityActionTypes.REMOVE_FF_SECURITY_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case fieldForceSecurityActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    default:
      return null;
  }
}

function FFSecurityFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case fieldForceSecurityActionTypes.LOG_FF_SECURITY_LIST_REQUEST:
      return logListReq(action, state);
    // log error
    case fieldForceSecurityActionTypes.GET_FF_SECURITY_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case fieldForceSecurityActionTypes.GET_FF_SECURITY_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case fieldForceSecurityActionTypes.GET_FF_SECURITY_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case fieldForceSecurityActionTypes.RESET_FF_SECURITY_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case fieldForceSecurityActionTypes.GET_FF_SECURITY_ONLOAD_RESPONSE:
      return {
        ...state,
        onloadData: action.data.onloadData,
      };
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}

const FFSecurityFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = FFSecurityFilterListConfig(state, action);
  const stateReqRes = FFSecurityFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default FFSecurityFilterList;
